/**
 * @generated SignedSource<<51adcc4cc3863f3040a59e50370946d9>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type AdminMembersReportDailyTimeSpentSectionQuery$variables = {
  id: string;
  inProductsViewerIsAdminOf?: boolean | null;
};
export type AdminMembersReportDailyTimeSpentSectionQuery$data = {
  readonly node: {
    readonly __typename: "OrganizationMembership";
    readonly __typename: "OrganizationMembership";
    readonly id: string;
    readonly productMemberships: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly id: string;
          readonly productId: string;
        };
      }>;
    } | null;
  } | {
    // This will never be '%other', but we need some
    // value in case none of the concrete values match.
    readonly __typename: "%other";
  } | null;
};
export type AdminMembersReportDailyTimeSpentSectionQuery = {
  response: AdminMembersReportDailyTimeSpentSectionQuery$data;
  variables: AdminMembersReportDailyTimeSpentSectionQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "inProductsViewerIsAdminOf"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": [
    {
      "kind": "Variable",
      "name": "inProductsViewerIsAdminOf",
      "variableName": "inProductsViewerIsAdminOf"
    },
    {
      "kind": "Literal",
      "name": "productType",
      "value": "course"
    }
  ],
  "concreteType": "ProductMembershipNodeConnection",
  "kind": "LinkedField",
  "name": "productMemberships",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ProductMembershipNodeEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ProductMembership",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v3/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "productId",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "AdminMembersReportDailyTimeSpentSectionQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              (v3/*: any*/),
              (v4/*: any*/)
            ],
            "type": "OrganizationMembership",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "AdminMembersReportDailyTimeSpentSectionQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              (v4/*: any*/)
            ],
            "type": "OrganizationMembership",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "ac599c007c79a660fc3fdcc71b675db9",
    "id": null,
    "metadata": {},
    "name": "AdminMembersReportDailyTimeSpentSectionQuery",
    "operationKind": "query",
    "text": "query AdminMembersReportDailyTimeSpentSectionQuery(\n  $id: ID!\n  $inProductsViewerIsAdminOf: Boolean\n) {\n  node(id: $id) {\n    __typename\n    ... on OrganizationMembership {\n      id\n      __typename\n      productMemberships(productType: \"course\", inProductsViewerIsAdminOf: $inProductsViewerIsAdminOf) {\n        edges {\n          node {\n            id\n            productId\n          }\n        }\n      }\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "ef74829b6b977199c91b1255b33558a9";

export default node;
